import { Injectable, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Mirador } from '../models/mirador';
import { MiradorCustomList } from '../models/mirador-custom-list';
import { MiradorList } from '../models/mirador-list';
import { MiradoresService } from './miradores.service';
import { UtilService } from './util.service';
import { FILTER_CHIPS, FilterChip } from '../enums & constants/filter-chips.constants';
import { OrganizerService } from './organizer.service';
import { AlbumsService } from './albums.service';
import { EXPERIENCES_LISTS } from '../enums & constants/list-experiences.constants';
import { ExperienceList } from '../models/experience-list';
import { ExperienceService } from './experience.service';

@Injectable({
  providedIn: 'root'
})
export class ListExperiencesService {

  experienceLists: ExperienceList[];
  allFilterChips:  FilterChip[];
  private _listsFullLoaded = new BehaviorSubject<boolean>(false);
  public $listsFullLoaded = this._listsFullLoaded.asObservable();

  constructor(public albumsService: AlbumsService,
    private utilService: UtilService,
    public ORGService: OrganizerService,
    private experienceService: ExperienceService,
  ) {

    this.experienceLists = JSON.parse(JSON.stringify(EXPERIENCES_LISTS));
    this.allFilterChips = JSON.parse(JSON.stringify(FILTER_CHIPS));

    this.experienceService.experiencesByCityRegion$.subscribe((data) => {
      this.fillAllExploreLists();
      this._listsFullLoaded.next(true);
    })
  }

  retryLoadedList() {
    // this.fillAllExploreLists();
    // this.fillAllExploreCustomLists();
    // this._listsFullLoaded.next(true);
  }

  fillAllExploreLists() {
    console.log(this.experienceLists);
    for (const experienceList of this.experienceLists) {
      experienceList.experiences = this.experienceService.getExperiencesByFilters(experienceList.filters);
    }
  }



  getListById(listId): Promise<MiradorList> {
    return new Promise((resolve) => {
      let res = (this.experienceLists.find(x => x.id == listId));
      resolve(res ? res : this.getDinamicListByParams(listId))
    });
  }

  getListByValue(value): Promise<MiradorList> {
    return new Promise((resolve) => {
      let res = this.experienceLists.find(x => this.utilService.getNormalizedNameForURL(x.filters[0].value) == value);
      resolve(res ? res : this.getDinamicListByParams(value));
    });
  }


  getDinamicListByParams(listId: any): Promise<MiradorList> {
    return new Promise(async (resolve) => {

      const filters = [{ type: "tags", value: this.utilService.getDesnormalizedNameForURL(listId) }];
      const newList: MiradorList = await {
        id: listId,
        name: this.utilService.getDesnormalizedNameForURL(listId), description: "",
        filters: filters,
        miradores: await this.albumsService.getMiradoresByFilters(filters)
      }

      this.experienceLists.push(newList);
      resolve(newList);

    });
  }

  onChipByList(list: MiradorList){
    let chip = this.allFilterChips.find(c => c.attachedList == list.id);
    if(chip) {
      this.albumsService.addFilter(chip.filters)
      this.albumsService.SetCurrentFilterChipSelected(chip);

    }else {
      this.albumsService.addFilter((list as MiradorList).filters)
      this.ORGService.setNewFilterChipByList((list as MiradorList).filters)
    }

  }
}
